import React, { Component } from "react";
import SubNav from "../../../shared/subnav/SubNav";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../../common/HasPermissionTo";
import styles from "./DashboardStyles.module.scss";
import DealerReporting from "./DealerReporting/DealerReporting";
import PendingActions from "../pendingActions/PendingActions";
import {
  IS_CANADA_MARKET,
  IS_NA_MARKET,
  IS_USA_MARKET,
} from "../../../utils/EmpUtil";
import { displayError, LOAD_ERROR } from "../../../errors/ErrorConstants";
import MainDashboard from "../dashboardCards/DashboardCards";
import { isCanadianPreorderUser } from "../../../utils/canadianPreorderExperience";
import DealerNotificationsClient from "../../../clients/DealerNotificationsClient";
import * as AnalyticsService from "../../../shared/services/analytics/AnalyticsService";
import { Paper } from "@mui/material";

class DealerDashboard extends Component {
  constructor(props) {
    super(props);
    this.dateRange = 7;
    this.state = {
      selectedTab: 0,
      renderApp: false,
      hasError: [],
      accesoriesPricingNotSet: false,
      dashboardNotifications: {},
    };
  }

  componentDidMount() {
    AnalyticsService.trackPageLoadEvent("fv:emp:dashboard", this.props.user);

    try {
      this.props.user.dashboardPage
        ? this.setState({ selectedTab: this.props.user.dashboardPage })
        : this.updateDashboardTab(this.state.selectedTab);
      this.setState({ renderApp: true });
    } catch {
      this.setState({ hasError: [LOAD_ERROR] });
    }

    this.getDealerDashboardNotifications();
  }

  componentWillUnmount() {
    if (this.modalTimeout) {
      clearTimeout(this.modalTimeout);
    }
  }

  handleTabChange = (event, selectedTab) => {
    this.updateDashboardTab(selectedTab);
    this.setState({ selectedTab });
  };

  getDealerDashboardNotifications = () => {
    DealerNotificationsClient.getDealerDashboardNotifications(this.props.user)
      .then((data) => {
        this.setState({
          dashboardNotifications: {
            ...data,
          },
        });
      })
      .catch(() => {
        this.hasError = true;
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  updateDashboardTab = (selectedTab) => {
    this.props.user.updateDashboardTab &&
      this.props.user.updateDashboardTab(selectedTab);
  };

  getTabs() {
    const tabs = [];

    !IS_NA_MARKET(this.props.user.market) &&
      tabs.push({
        menuName: this.props.t("ProgressBar.notifications"),
        enabled: true,
        id: "dashboard",
      });
    this.props.user.userType === "dealer" &&
      tabs.push({
        menuName: this.props.t("ProgressBar.reporting"),
        enabled: true,
        id: "reporting",
      });
    return tabs;
  }

  render() {
    if (displayError(this.state.hasError)) {
      throw new Error(this.state.hasError[0]);
    }

    return (
      this.state.renderApp && (
        <div id="dashboard" className="pageWrapper">
          <HasPermissionTo
            perform={["dealerReporting:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            render={() => {
              return (
                <>
                  <SubNav
                    dashboard={true}
                    selectedTab={this.state.selectedTab}
                    title={this.props.t("GlobalNavBar.dashboard")}
                    action={this.handleTabChange}
                    tabs={this.getTabs()}
                    {...this.props}
                    isDealer={true}
                  />
                </>
              );
            }}
            noRender={() => {
              return (
                <>
                  <SubNav
                    id="subNav"
                    dashboard={true}
                    title={this.props.t("GlobalNavBar.dashboard")}
                    {...this.props}
                    isDealer={true}
                  />
                </>
              );
            }}
          />

          {this.state.selectedTab === 0 ? (
            <HasPermissionTo
              perform={["pendingActionQueue:view"]}
              permissions={this.props.user.permissions.rolePermissions}
              render={() => <PendingActions {...this.props} />}
            />
          ) : (
            <HasPermissionTo
              perform={["dealerReporting:view"]}
              permissions={this.props.user.permissions.rolePermissions}
              condition={this.state.selectedTab === 1}
              render={() => <DealerReporting {...this.props} />}
            />
          )}
          <HasPermissionTo
            perform={
              isCanadianPreorderUser(this.props.user) ? [] : ["dashboardCards"]
            }
            permissions={this.props.user.permissions.rolePermissions}
            condition={
              IS_USA_MARKET(this.props.user.market) ||
              IS_CANADA_MARKET(this.props.user.market)
            }
            render={() => (
              <MainDashboard
                {...this.props}
                accesoriesPricingNotSet={this.state.accesoriesPricingNotSet}
                dashboardNotifications={this.state.dashboardNotifications}
                getDealerDashboardNotifications={() =>
                  this.getDealerDashboardNotifications()
                }
              />
            )}
            noRender={() => {
              return (
                (IS_USA_MARKET(this.props.user.market) ||
                  IS_CANADA_MARKET(this.props.user.market)) && (
                  <Paper className={styles.comingSoonContainer}>
                    <div
                      className={styles.comingSoonTitle}
                      data-testid="comingSoonTitle"
                    >
                      {this.props.t("DealerDashboard.comingSoonTitle")}
                    </div>
                    <div
                      className={styles.comingSoonPrimaryText}
                      data-testid="comingSoonPrimaryText"
                    >
                      {this.props.t("DealerDashboard.comingSoonPrimaryText")}
                    </div>
                    <div
                      className={styles.comingSoonSecondaryText}
                      data-testid="comingSoonSecondaryText"
                    >
                      {this.props.t("DealerDashboard.comingSoonSecondaryText")}
                    </div>
                  </Paper>
                )
              );
            }}
          />
        </div>
      )
    );
  }
}

export default withTranslation("emp")(DealerDashboard);
